import { useState } from "react";
import { parseCountries, toMinorUnits } from "./marketingFormat";

const DEFAULT_DAYS = "7";

/** Budget, run length and audience shared by every dialog that creates something Meta will deliver. */
export function useDeliveryPlan() {
  const [fields, setFields] = useState({
    budget: "",
    days: DEFAULT_DAYS,
    countries: "AU",
    ageMin: "18",
    ageMax: "65",
  });
  const set = (name) => (value) => setFields((current) => ({ ...current, [name]: value }));

  const cents = toMinorUnits(fields.budget);
  const dayCount = Number(fields.days);
  const daysValid = Number.isInteger(dayCount) && dayCount >= 1 && dayCount <= 90;
  const ages = { min: Number(fields.ageMin), max: Number(fields.ageMax) };
  const agesValid = ages.min >= 18 && ages.max <= 65 && ages.min <= ages.max;
  const countryCodes = parseCountries(fields.countries);
  const countriesValid = countryCodes.length > 0 && countryCodes.every((c) => /^[A-Z]{2}$/.test(c));

  return {
    fields,
    set,
    cents,
    dayCount,
    daysValid,
    agesValid,
    countriesValid,
    valid: Boolean(cents) && daysValid && agesValid && countriesValid,
    payload: {
      dailyBudgetCents: cents,
      durationDays: dayCount,
      countries: countryCodes,
      ageMin: ages.min,
      ageMax: ages.max,
    },
  };
}
